import { useContext, useEffect, useState } from 'react';
import Select, {
  components,
  SingleValue,
  ValueContainerProps,
} from 'react-select';
import ShippingDetails from './ShippingDetails';
import {
  OrderCancelationReason,
  ReactSelectOptionProp,
  ShopifyCustomerAddress,
} from '../interface/interface';
import { CartContext } from '../context/cartContext';
import TextAreaWithLimit from './TextArea';

function RequestToOrderCancellation(props: {
  orderId?: string;
  cart: any;
  addressList?: ShopifyCustomerAddress[];
  addShipping: (
    shippingDetails: ShopifyCustomerAddress,
  ) => Promise<boolean | void> | void;
  handleSelectedReason: (value: ReactSelectOptionProp | null) => void;
  handleOtherReason: (value: string) => void;
  editShippingEnabled: boolean;
  isButtonLoadingEnable?: boolean;
  isForRequestToCancel?: boolean;
  selectedReason: ReactSelectOptionProp | null;
  reason: string;
}) {
  const {
    addShipping,
    editShippingEnabled,
    handleSelectedReason,
    handleOtherReason,
    isButtonLoadingEnable,
    reason,
    addressList,
  } = props;
  const { cart } = useContext(CartContext);
  const [cancelOrderReason, setCancelOrderReason] = useState<
    ReactSelectOptionProp[]
  >([]);
  const [selectedReason, setSelectedReason] =
    useState<ReactSelectOptionProp | null>(null);

  useEffect(() => {
    setCancelOrderReason([
      {
        label: OrderCancelationReason.SHIPPING_ADDRESS_INCORRECT,
        value: OrderCancelationReason.SHIPPING_ADDRESS_INCORRECT,
      },
      {
        label: OrderCancelationReason.NO_LONGER_NEEDED,
        value: OrderCancelationReason.NO_LONGER_NEEDED,
      },
      {
        label: OrderCancelationReason.WRONG_PRODUCT_OR_STRENGTH,
        value: OrderCancelationReason.WRONG_PRODUCT_OR_STRENGTH,
      },
      {
        label: OrderCancelationReason.SPEAK_WITH_DOCTOR,
        value: OrderCancelationReason.SPEAK_WITH_DOCTOR,
      },
      {
        label: OrderCancelationReason.OTHER_LABEL,
        value: OrderCancelationReason.OTHER,
      },
    ]);
  }, []);

  const ValueContainer = ({ children, ...props }: ValueContainerProps<any>) => {
    const [values, input] = children as any;
    return (
      <components.ValueContainer {...props} key={values}>
        {values}
        {input}
      </components.ValueContainer>
    );
  };

  return (
    <>
      <p>Reason for Cancel Request</p>
      <div className="mt-2">
        <Select
          classNames={{
            control: (state) =>
              `${
                state.isFocused
                  ? 'border-grey-400 border text-sm'
                  : 'border-grey-400 border text-sm'
              } cursor-pointer`,
          }}
          value={selectedReason}
          options={cancelOrderReason}
          onChange={(selected: SingleValue<ReactSelectOptionProp>) => {
            handleSelectedReason(selected);
            setSelectedReason(selected);
          }}
          styles={{ menu: (base) => ({ ...base, position: 'relative' }) }}
          isSearchable
          hideSelectedOptions={false}
          isMulti={false}
          components={{ ValueContainer }}
          placeholder="Select..."
        />

        {selectedReason?.value === OrderCancelationReason.OTHER ? (
          <div className="mt-5 flex flex-col justify-between">
            <label htmlFor="reason">Other: </label>
            <TextAreaWithLimit
              maxLength={256}
              text={reason}
              onTextChange={(text: string) => {
                handleOtherReason(text);
              }}
              className="!h-24"
            />
          </div>
        ) : null}

        {selectedReason?.value ===
        OrderCancelationReason.SHIPPING_ADDRESS_INCORRECT ? (
          <div className="mt-5">
            <h2 className="text-base xl:text-xl text-primary-blue-500 font-semibold mt-10 mb-3">
              Shipping Details
            </h2>
            <ShippingDetails
              cart={cart}
              addressList={addressList as Array<ShopifyCustomerAddress>}
              isAddressListFetching={false}
              addShipping={addShipping}
              editShippingEnabled={editShippingEnabled}
              isForRequestToCancel
              isButtonLoadingEnable={isButtonLoadingEnable}
            />
          </div>
        ) : null}
      </div>
    </>
  );
}

export default RequestToOrderCancellation;
